import React, { useState, useEffect } from "react";
import { Box, Grid, Backdrop } from "@material-ui/core";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { ax } from "src/common/api/apiClient";
import { IApi } from "src/common/typings/app";
import Heading from "./Heading";
import { InputFields, IForm } from "./InputFields";
import { useStyles } from "./styles";
import CommonLoader from "src/components/Loader/CommonLoader";

type Props = {
  children?: React.ReactNode;
  index: any;
  value: any;
};

export function FileTypes({ value, index, ...other }: Props): React.ReactElement {
  const classes = useStyles();
  const [loader, setLoader] = useState(false);
  const [tableRecord, settableRecord] = React.useState<any[]>([]);
  const pageHeading = "File Types";
  const [loading, setLoading] = React.useState(false);

  const getListing = async () => {
    let results: any = [];
    try {
      setLoader(true);
      results = await fetchWrapper.get("get-all-file-categories");
      if (results.isSuccess == true) {
        settableRecord(results.value);
      }
      setLoader(false);
      return;
    } catch (error: any) {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (tableRecord.length === 0) getListing();
  }, []);

  const updateSubmit = async (formData: IForm) => {
    setLoading(true);
    try {
      const clone = JSON.parse(JSON.stringify(formData));
      const res = await ax.put<IApi>("/update-file-category", clone);
      if (res.data.isSuccess === true) {
        setLoading(false);
        const tempArr = tableRecord.map((x) =>
          x.id === formData.id ? { ...x, name: formData.name, isActive: formData.isActive } : x
        );
        settableRecord(tempArr);
      } else {
        setLoading(false);
        throw new Error(res.data.error || res.statusText);
      }
    } catch (err) {
      setLoading(false);
    }
  };
  const handleSubmit = async (formData: IForm) => {
    try {
      setLoading(true);
      const clone = JSON.parse(JSON.stringify(formData));
      const res = await ax.post<IApi>("/create-file-category", clone);
      if (res.data.isSuccess === true) {
        setLoading(false);
        getListing();
      } else {
        throw new Error(res.data.error || res.statusText);
      }
    } catch (err) {
      setLoading(false);
    }
  };

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <>
          <Backdrop className={classes.backdrop} open={loader}>
            <CommonLoader />
          </Backdrop>
          <Box borderColor="grey.200">
            <Heading heading={pageHeading} />
            <Box borderTop={2} mb={1} borderColor="grey.200"></Box>
            <Grid container direction="row">
              <Grid item xs={12} md={12}>
                {/* Conent Start */}
                <InputFields
                  updateSubmit={updateSubmit}
                  handleSubmit={handleSubmit}
                  tableRecord={tableRecord || []}
                  loading={loading}
                />
                {/* Conent End */}
              </Grid>
            </Grid>
          </Box>
        </>
      )}
    </div>
  );
}
